import { padStart } from 'lodash';
import Vue from 'vue';
const TWEEN = require('@tweenjs/tween.js');
let animatedCountTween;
let animationFrame;
const animate = function(currentTime) {
    animationFrame = requestAnimationFrame(animate);
    TWEEN.update();
}
let animatedCountDestination;

const element = document.getElementById('stock-list-header');
const vueApp = new Vue({
    el: '#stock-list-header',
    data: {
        count: 0,
        digit1: '-',
        digit2: '-',
        digit3: '-',
    },
    created() {
        window.addEventListener('stock_list_count_update', event => {
            if (typeof event.detail.count == 'undefined') {
                return;
            }
            this.animateCount(event.detail.count);
        });
        element.dataset.loaded = 1;
    },
    methods: {
        animateCount(targetCount) {
            // If the value of the count has changed, we need to initialize the animation of the number
            if (targetCount !== animatedCountDestination) {
                // If we don't have a TWEEN object setup already then set it up
                if (!animatedCountTween) {
                    let countObject = {count:0};
                    animatedCountTween = new TWEEN.Tween(countObject);
                    animatedCountTween.to({count: targetCount}, 500)
                    .onUpdate((countObject) => {
                        this.count = parseInt(countObject.count);
                        const stringCount = padStart(this.count, 3, '0')
                        this.digit1 = stringCount.substring(0, 1);
                        this.digit2 = stringCount.substring(1, 2);
                        this.digit3 = stringCount.substring(2, 3);
                    })
                    .onComplete(function() {
                        cancelAnimationFrame(animationFrame);
                    })
                    .onStop(function() {
                        cancelAnimationFrame(animationFrame);
                    });
                    animatedCountTween.start();
                    animatedCountDestination = targetCount;

                    animate();
                    return;
                }
                // Otherwise use the existing TWEEN object
                animatedCountTween.stop();
                animatedCountTween.to({count: targetCount}, 500);
                animatedCountTween.start();
                animatedCountDestination = targetCount;

                animate();
            }
        },
    },
});


// WEBPACK FOOTER //
// ./resources/assets/js/events/2023/stock-list/header.js